export default {"src":"https://filecdn-other.xingyeai.com/xingye-ugc/_next/static/media/play.021c3e5b.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};